import React, { FunctionComponent, useCallback, useState } from 'react';

import { CustomSlotComponentRendererProps } from '@yandex-video-platform/goloom-sdk-react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../shared/helpers/i18n';
import { useShareCallData } from '../../hooks/share-call-data.hook';
import { isShareConferenceLinkSuccessSelector, selectIsNewGrid } from '../../selectors';
import { CopyButton } from '../copy-button';
import ShareButtons from '../share-buttons';
import CopyUrlButton from './copy-url-button';
import css from './index.css';
import { InviteProps } from './types';

const Invite: FunctionComponent<CustomSlotComponentRendererProps & InviteProps> = ({
    style,
    className,
    innerWrapperClassName,
}) => {
    const isShareConferenceLinkSuccess = useSelector(isShareConferenceLinkSuccessSelector);
    const isNewGrid = useSelector(selectIsNewGrid);

    const [wasUrlCopied, setUrlCopied] = useState(isShareConferenceLinkSuccess);

    const { callNumber, copyConferenceUrlToClipboard, copyCallNumberToClipboard } = useShareCallData();

    const onCopyUrl = useCallback(() => {
        copyConferenceUrlToClipboard();
        setUrlCopied(true);
    }, [copyConferenceUrlToClipboard]);

    const onCopyIdClick = useCallback(() => {
        copyCallNumberToClipboard();
        setUrlCopied(false);
    }, [copyCallNumberToClipboard]);

    return (
        <div className={cn(css.Invite, { [css.newGridItem]: isNewGrid }, className)} style={style}>
            <div className={cn(css.InviteInner, innerWrapperClassName)}>
                <div className={css.ContentWrapper}>
                    <div className={css.mainTextWrapper}>
                        <svg viewBox="0 0 444 60">
                            <foreignObject x="0" y="0" width="100%" height="100%">
                                {/* @ts-expect-error */}
                                <div xmlns="http://www.w3.org/1999/xhtml" className={css.MainText}>
                                    {i18n('call', 'share-link-title')}
                                </div>
                            </foreignObject>
                        </svg>
                    </div>
                    <div className={css.ButtonsWrapper}>
                        <CopyUrlButton onCopyUrl={onCopyUrl} setWasCopied={setUrlCopied} wasCopied={wasUrlCopied} />
                        <ShareButtons className={css.ShareButtonsWrapper} />
                    </div>
                    <div className={css.MeetingNumber}>
                        <div className={css.MeetingNumberText}>
                            {i18n('call', 'share-link-meeting-number', { number: callNumber })}
                        </div>
                        <CopyButton
                            className={css.CopyNumberButton}
                            onClick={onCopyIdClick}
                            title={i18n('common', 'copy-link-short')}
                            testId="copy-link-short-button"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Invite;
